// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info-form__pricing-model-cont .pricing-model-tile.pricing-model-tile {\n  width: 100%;\n  max-width: initial;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
